var _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Design100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ec71ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#876bdb"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ff3ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#583aff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#9170a1",
    d: "M 21.5,6.5 C 23.1992,6.33982 24.8659,6.50649 26.5,7C 34,14.5 41.5,22 49,29.5C 50.7923,22.1514 55.2923,16.4847 62.5,12.5C 63.086,12.7093 63.586,13.0426 64,13.5C 66.2047,10.9598 68.7047,8.79315 71.5,7C 74.9643,6.1834 78.2976,6.51674 81.5,8C 87.3273,12.8164 91.994,18.4831 95.5,25C 94.1024,29.781 91.4357,33.781 87.5,37C 88.5348,38.5069 88.3681,40.0069 87,41.5C 84.1667,44.3333 81.3333,47.1667 78.5,50C 76.0588,50.036 74.0588,50.8693 72.5,52.5C 79.4854,59.9857 86.652,67.319 94,74.5C 94.6667,76.5 94.6667,78.5 94,80.5C 88.5,86 83,91.5 77.5,97C 75.1667,97.6667 72.8333,97.6667 70.5,97C 63.3333,89.8333 56.1667,82.6667 49,75.5C 43.1356,81.699 36.9689,87.5323 30.5,93C 22.2175,94.3291 13.8841,95.1625 5.5,95.5C 5.88267,87.1243 6.716,78.7909 8,70.5C 14.0149,64.6521 19.8482,58.6521 25.5,52.5C 18.5146,45.0143 11.348,37.681 4,30.5C 3.33333,28.5 3.33333,26.5 4,24.5C 9.36493,17.9695 15.1983,11.9695 21.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea7799",
    d: "M 73.5,9.5 C 76.2257,9.26386 78.559,10.0972 80.5,12C 84.3689,15.5338 87.8689,19.3672 91,23.5C 90.8249,27.893 88.6583,31.2263 84.5,33.5C 78.5,28.1667 72.8333,22.5 67.5,16.5C 69.5227,14.1472 71.5227,11.8138 73.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "left-ruler",
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 22.5,10.5 C 26.1331,10.443 26.2998,11.443 23,13.5C 22.2195,14.9437 22.3861,16.277 23.5,17.5C 25.1487,16.3523 26.6487,15.019 28,13.5C 31.0551,16.8009 30.3884,19.4676 26,21.5C 25.5172,22.448 25.3505,23.448 25.5,24.5C 26.552,24.6495 27.552,24.4828 28.5,24C 30.0175,22.3149 31.6841,20.8149 33.5,19.5C 37.2097,21.241 37.3764,23.241 34,25.5C 33.2506,26.635 33.4173,27.635 34.5,28.5C 36.1487,27.3523 37.6487,26.019 39,24.5C 40.1667,25.6667 41.3333,26.8333 42.5,28C 40.316,30.0165 38.316,32.1831 36.5,34.5C 37.365,35.5827 38.365,35.7494 39.5,35C 41.0175,33.3149 42.6841,31.8149 44.5,30.5C 45.5,30.8333 46.1667,31.5 46.5,32.5C 41.1667,38.5 35.5,44.1667 29.5,49.5C 21.681,42.1812 14.0143,34.6812 6.5,27C 12.0363,21.6314 17.3697,16.1314 22.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0cae5",
    d: "M 60.5,17.5 C 61.552,17.3505 62.552,17.5172 63.5,18C 70.8691,25.0267 77.7025,32.1933 84,39.5C 82.6012,40.2266 81.1012,40.7266 79.5,41C 78.1131,43.045 76.9464,45.2117 76,47.5C 69,40.5 62,33.5 55,26.5C 54.5172,25.552 54.3505,24.552 54.5,23.5C 58.8333,23.8333 60.8333,21.8333 60.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#967dab",
    d: "M 63.5,23.5 C 66.1445,25.6601 65.8111,27.6601 62.5,29.5C 61.5,29.1667 60.8333,28.5 60.5,27.5C 61.5244,26.1482 62.5244,24.8149 63.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9377a7",
    d: "M 68.5,29.5 C 69.5,29.5 70.5,29.5 71.5,29.5C 71.5,32.8333 69.8333,34.5 66.5,34.5C 66.3915,32.4862 67.0582,30.8195 68.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "left-pencil",
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 58.5,35.5 C 56.8333,37.8333 54.8333,39.8333 52.5,41.5C 49.9438,42.5434 47.7772,44.2101 46,46.5C 45.4719,47.816 45.9719,48.4827 47.5,48.5C 46.0736,49.3412 44.7403,50.3412 43.5,51.5C 43.1034,50.475 42.4368,50.3083 41.5,51C 34.5,58 27.5,65 20.5,72C 17.8424,72.0729 15.1757,71.7396 12.5,71C 25.8333,57.6667 39.1667,44.3333 52.5,31C 55.1207,31.4265 57.1207,32.9265 58.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#977fad",
    d: "M 74.5,34.5 C 75.9953,34.4148 76.9953,35.0815 77.5,36.5C 76.5,38.1667 75.1667,39.5 73.5,40.5C 72.5,40.1667 71.8333,39.5 71.5,38.5C 72.5244,37.1482 73.5244,35.8149 74.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "middle pencil",
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 58.5,35.5 C 61.1667,37.5 63.5,39.8333 65.5,42.5C 61.8333,45.8333 58.1667,49.1667 54.5,52.5C 45.0877,60.408 36.0877,68.908 27.5,78C 25.8659,78.4935 24.1992,78.6602 22.5,78.5C 22.3398,76.8008 22.5065,75.1341 23,73.5C 30.4275,66.5777 37.2608,59.2444 43.5,51.5C 44.7403,50.3412 46.0736,49.3412 47.5,48.5C 50.3644,46.9767 52.031,44.6433 52.5,41.5C 54.8333,39.8333 56.8333,37.8333 58.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9170a0",
    d: "M 52.5,41.5 C 52.031,44.6433 50.3644,46.9767 47.5,48.5C 45.9719,48.4827 45.4719,47.816 46,46.5C 47.7772,44.2101 49.9438,42.5434 52.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "right-pencil",
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 65.5,42.5 C 68.0735,43.8793 69.5735,45.8793 70,48.5C 57,61.5 44,74.5 31,87.5C 29.3067,85.4245 28.64,83.0911 29,80.5C 37.3333,72.1667 45.6667,63.8333 54,55.5C 54.4828,54.552 54.6495,53.552 54.5,52.5C 58.1667,49.1667 61.8333,45.8333 65.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "right-ruler",
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 68.5,54.5 C 69.0431,54.56 69.3764,54.8933 69.5,55.5C 68.2887,56.8745 67.2887,58.3745 66.5,60C 66.8333,60.5 67.1667,61 67.5,61.5C 69.1487,60.3523 70.6487,59.019 72,57.5C 73.1667,58.6667 74.3333,59.8333 75.5,61C 73.316,63.0165 71.316,65.1831 69.5,67.5C 70.365,68.5827 71.365,68.7494 72.5,68C 74.0175,66.3149 75.6841,64.8149 77.5,63.5C 81.2097,65.241 81.3764,67.241 78,69.5C 77.2506,70.635 77.4173,71.635 78.5,72.5C 80.1487,71.3523 81.6487,70.019 83,68.5C 84.1667,69.6667 85.3333,70.8333 86.5,72C 84.316,74.0165 82.316,76.1831 80.5,78.5C 81.365,79.5827 82.365,79.7494 83.5,79C 85.0175,77.3149 86.6841,75.8149 88.5,74.5C 89.8333,75.1667 90.8333,76.1667 91.5,77.5C 86.1667,83.5 80.5,89.1667 74.5,94.5C 66.681,87.1812 59.0143,79.6812 51.5,72C 57.3696,66.2981 63.0362,60.4647 68.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6ebdc",
    d: "M 10.5,73.5 C 13.5,74.1667 16.5,74.8333 19.5,75.5C 19.8333,77.5 20.1667,79.5 20.5,81.5C 22.4672,81.2606 24.3005,81.5939 26,82.5C 26.8215,85.1168 27.3215,87.7835 27.5,90.5C 13.5,93.1667 7.83333,87.5 10.5,73.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Design100);
export default __webpack_public_path__ + "static/media/icons8-design-100.5da245065b384badd5146837631113a9.svg";
export { ForwardRef as ReactComponent };